import { money } from '../../lib/format';
import { Pricing } from '../../types/commerce';
import './ProductPrice.css';
export default function ProductPrice({ pricing, price }: { pricing?: Pricing | null; price?: number }) {
  if (!pricing) return <span className="product-price">{money(Number(price ?? 0) * 100)}</span>;
  return (
    <span className="product-price">
      {pricing.savings_paise > 0 && <del aria-label="Original price">{money(pricing.original_paise)}</del>}{' '}
      <strong>{money(pricing.current_paise)}</strong>
      {pricing.savings_paise > 0 && (
        <small>
          {pricing.discount_percent}% off · Save {money(pricing.savings_paise)}
        </small>
      )}
    </span>
  );
}
